import React from 'react';
import bem from 'utils/bem';
import { Short3RowsTeaser } from 'components/SpecialistTeaser';
import { IconButton } from 'components/Button';
import Text from 'components/Text';
import Icon from 'components/Icon';
import OrderDetails from 'components/OrderDetails';
import './index.sass';
import { Info } from 'components/Info';
import { GreenText } from 'components/GreenText';
import { TextWithPulsingDot } from 'components/TextWithPulsingDot';

const { block, el } = bem('order-form-success');

const OrderFormSuccess = ({ order, onOrderMoreClick, onClose }) => {

    const specialist = order.data.specialist;
    const events = order.events;
    const address = order.data.event?.address ? order.data.event?.address : null;
    const meetingType = order.data.service.meetingType;
    const workingOffline = meetingType === 'OFF';
    const workingWithPairs = !!order.data?.pairVisit;
    const city = workingOffline ? order.data.event.address.town : null;
    const district = workingOffline ? order.data.event.address.district : null;
    const skype = !workingOffline ? order.data.specialist.skype : null;
    const problem = order.data?.customer?.ask ?? null;

    const OrderDetailsWidget =
        <OrderDetails
            problem={problem}
            workingOffline={ workingOffline }
            workingOfflineText={ workingOffline ?
                'Очная встреча' :
                <TextWithPulsingDot hasBackground={true}>
                    <GreenText>Онлайн-встреча</GreenText>
                </TextWithPulsingDot> }
            workingWithPairs={ workingWithPairs }
            city={ city }
            district={ district }
            skype={ skype }
            events={ events }
            address={ address }
        />;

    return (
        <div className={block()}>
            <div className={el('header')}>
                <div className={el('close')} onClick={onClose}><Icon name={'x'}/></div>
            </div>
            <div className={el('content')}>
                <div className={el('stars')} />
                <div className={el('message')}>
                    <Text tag={'div'}>{`Вы успешно оплатили и записались на консультацию.\nПодробные детали были отправлены на указанный вами email.`}
                    </Text>
                </div>
                <div className={el('specialist-block')}>
                    <Short3RowsTeaser specialist={ specialist }/>
                    <div className={ el('separator') }/>
                    <Info type='notification'>
                        <Text tag={'div'} style={{fontSize: '14px', fontWeight: 400}}>У вас <GreenText>онлайн</GreenText> встреча</Text>
                        <Text tag={'div'}>Пожалуйста, готовьте к онлайн встрече за 10-15 минут до начала</Text>
                    </Info>
                    <div className={ el('details-block') }>
                        { OrderDetailsWidget }
                    </div>
                    <Info type='info'>
                        <Text tag={'div'}>Время начала консультации указано по Московскому времени</Text>
                    </Info>
                </div>
                <div className={el('buttons')}>
                    <IconButton name={'arrow-counter-clockwise'} onClick={onOrderMoreClick} mod={'transparent-gold'}><Text>Записаться еще</Text></IconButton>
                    <IconButton name={'user-circle'} to={'/orders'} mod={'gold'}><Text>В личный кабинет</Text></IconButton>
                </div>
            </div>
        </div>
    )
}

export default OrderFormSuccess;
